import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Redirect } from 'react-router-dom';
import { Constants } from "../../constants";
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';

class OrderInquiryBasicInfo extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            input: props.data,
            errors: {}
        };
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate(event) {

        let input = this.state.input;
        let errors = {};
        let isValid = true;

        return true;
        if (!input["firstname"]) {
            isValid = false;
            errors["firstname"] = "Please enter your name.";
        }
        if (!input["lastname"]) {
            isValid = false;
            errors["lastname"] = "Please enter your name.";
        }

        if (!input["email"]) {
            isValid = false;
            errors["email"] = "Please enter your email Address.";
        }

        if (!input["password"]) {
            isValid = false;
            errors["password"] = "Please enter your password.";
        }

        if (!input["confirmpassword"]) {
            isValid = false;
            errors["confirmpassword"] = "Please enter your confirm password.";
        }

        if (typeof input["password"] !== "undefined" && typeof input["confirmpassword"] !== "undefined") {

            if (input["password"] != input["confirmpassword"]) {
                isValid = false;
                errors["password"] = "Passwords don't match.";
            }
        }

        console.log(this.state.values);
        console.log(errors);

        this.setState({
            errors: errors
        });

        return isValid;
    }


    render() {
        return (
            <Form as={Row} style={this.props.style}>
                <Col md={6}>
                    <Form.Group as={Row} className="mb-3" >
                        <Form.Label column md={2} >Created Date</Form.Label>
                        <Col md={10}>
                            <Form.Control type="input" name="CreatedDate" value={moment(this.state.input.CreatedDate).format('MM/DD/YYYY')} disabled/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column md={2}>Order Number</Form.Label>
                        <Col md={10}>
                            <Form.Control type="input" name="orderNum" value={this.state.input.OrderNumber} disabled />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column md={2}>PO Number</Form.Label>
                        <Col md={10}>
                            <Form.Control type="input" name="poNumber" value={this.state.input.PurchaseOrder} disabled />
                        </Col>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group as={Row} className="mb-3" >
                        <Form.Label column md={2}>Order Type</Form.Label>
                        <Col md={10}>
                            <Form.Control type="input" name="orderType" value={this.state.input.OrderType} disabled />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column md={2}>{this.state.input.EndDate == null ? "Service Call ID" : "Contract Number"}</Form.Label>
                        <Col md={10}>
                            <Form.Control type="input" name="orderNum" value={this.state.input.DisplayID} disabled />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" hidden={this.state.input.EndDate != null}>
                        <Form.Label column md={2}>Service Type</Form.Label>
                        <Col md={10}>
                            <Form.Control type="input" name="orderNum" value={this.state.input.CallTypeDescription} disabled />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column md={2}>Building Name</Form.Label>
                        <Col md={10}>
                            <Form.Control type="input" name="buildingName" value={this.state.input.BuildingName} disabled />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column md={2}>Description</Form.Label>
                        <Col md={10}>
                            <Form.Control as="textarea" rows={3} name="orderDescription" value={this.state.input.OrderDescription} disabled />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" hidden={this.state.input.OrderType != 'Contract'}>
                        <Form.Label column md={2}>Expiration Date</Form.Label>
                        <Col md={10}>
                            <Form.Control type="input" name="expirationDate" value={moment(this.state.input.EndDate).format('MM/DD/YYYY')} disabled />
                        </Col>
                    </Form.Group>
                </Col>
            </Form>
        );
    }
}

export default OrderInquiryBasicInfo;